import { RouteConfig } from "vue-router";
import { RCandidatesBrowse } from "./Browse/RCandidatesBrowse";
import { RCandidateProfile } from "./Profile/RCandidateProfile";

export const REmployerCandidates: RouteConfig = {
  path: "sponsorship_candidates/:tabTypeId(\\d+)",
  component: () =>
    import(
      /* webpackChunkName: "employer-teammates" */
      "./VEmployerCandidates.vue"
    ),
  meta: {
    title: "Candidates",
    icon: "settings-outline",
    hide: true,
  },
  children: [RCandidatesBrowse, RCandidateProfile],
};
